/* eslint-disable consistent-return */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SyncTimeoutIndicatorProps } from './SyncTimeoutIndicator.types';

const useSyncTimeoutIndicator = ({ expirationDate, onComplete }: SyncTimeoutIndicatorProps) => {
  const { t } = useTranslation();
  const [timeRemaining, setTimeRemaining] = useState<number>(0);

  useEffect(() => {
    if (!expirationDate) {
      setTimeRemaining(0);
      return;
    }

    const calculateRemaining = () => {
      const remaining = Math.ceil((expirationDate.getTime() - new Date().getTime()) / 1000);
      return remaining > 0 ? remaining : 0;
    };

    const initialRemaining = calculateRemaining();
    setTimeRemaining(initialRemaining);

    if (initialRemaining <= 0) {
      onComplete();
      return;
    }

    const interval = setInterval(() => {
      const remaining = calculateRemaining();
      setTimeRemaining(remaining);
      if (remaining <= 0) {
        clearInterval(interval);
        onComplete();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [expirationDate, onComplete]);

  return {
    t,
    timeRemaining,
  };
};

export default useSyncTimeoutIndicator;
